var _circle, _path, _path2, _circle2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2926,
    r: 25,
    fill: "#64DD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 24.1138L16.8956 30.4536L16.8956 17.774L27.8765 24.1138Z",
    fill: "#64DD17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.468 7.13538L19.4685 26.0182C19.4685 29.1843 21.5938 31.9561 24.6513 32.778L38.7687 36.5729L41.1437 27.8229L28.5318 24.3854L28.5318 7.13538L19.468 7.13538Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2926,
    r: 25,
    fill: "#64DD17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 24.1138L16.8956 30.4536L16.8956 17.774L27.8765 24.1138Z",
    fill: "#64DD17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2561 7.03015H23.2239V27.3551L40.9375 37.7614L43 34.3864L27.2561 25.027V7.03015Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammed);
export default __webpack_public_path__ + "static/media/programmed.c58260dd5a3a06bf740a286a164e624d.svg";
export { ForwardRef as ReactComponent };